import { getThemeColors } from '../configs/theme.colors'

export const ConfidenceLevels = {
    NOT_CONFIDENT: 1,
    MODERATELY_CONFIDENT: 2,
    CONFIDENT: 3,
    VERY_CONFIDENT: 4,
}

export const getConfidenceLevelName = confidenceLevel => {
    switch (confidenceLevel) {
        case ConfidenceLevels.NOT_CONFIDENT:
            return 'Not Confident'
        case ConfidenceLevels.MODERATELY_CONFIDENT:
            return 'Moderately Confident'
        case ConfidenceLevels.CONFIDENT:
            return 'Confident'
        case ConfidenceLevels.VERY_CONFIDENT:
            return 'Very Confident'
        default:
            return 'Unknown Confidence level'
    }
}

export const getConfidenceLevelNoun = confidenceLevel => {
    switch (confidenceLevel) {
        case ConfidenceLevels.NOT_CONFIDENT:
            return 'Lack of Confidence'
        case ConfidenceLevels.MODERATELY_CONFIDENT:
            return 'Moderate Confidence'
        case ConfidenceLevels.CONFIDENT:
            return 'Confidence'
        case ConfidenceLevels.VERY_CONFIDENT:
            return 'High Confidence'
        default:
            return 'Unknown Confidence level'
    }
}

export const getConfidenceLevelColor = confidenceLevel => {
    const themeMode = document.documentElement.getAttribute('data-theme') || 'light'
    const colors = getThemeColors(themeMode)
    
    switch (confidenceLevel) {
        case ConfidenceLevels.NOT_CONFIDENT:
            return colors.error
        case ConfidenceLevels.MODERATELY_CONFIDENT:
            return colors.warning
        case ConfidenceLevels.CONFIDENT:
            return colors.success
        case ConfidenceLevels.VERY_CONFIDENT:
            // Use a darker success color for very confident
            return colors.successDark || colors.success // fallback to normal success if not available
        default:
            return colors.text
    }
}

export const getConfidenceLevelTagColor = confidenceLevel => {
    switch (confidenceLevel) {
        case ConfidenceLevels.NOT_CONFIDENT:
            return 'error'
        case ConfidenceLevels.MODERATELY_CONFIDENT:
            return 'warning'
        case ConfidenceLevels.CONFIDENT:
            return 'success'
        case ConfidenceLevels.VERY_CONFIDENT:
            return 'success'
        default:
            return '#processing'
    }
}
